<!--
// app/components/pages/region-matches/HomeTeam.vue
-->
<script setup lang="ts">
import type { Team } from "#shared/team/domain/models/Team";
import { setAliasUrl } from "#shared/Shared/utils";

type Props = {
  team: Team | undefined;
  isWinner: boolean;
  isKok?: boolean;
};

const props = defineProps<Props>();
</script>

<template>
  <div class="flex items-center justify-end gap-1 lg:gap-4 text-white">
    <p :class="['text-lg text-right rtl:text-left hidden lg:block w-full', { 'text-primary': isWinner }]">
      {{ team.completeName }}
    </p>
    <div class="flex flex-col text-right rtl:text-left items-center lg:hidden">
      <p
        :class="[
          'text-base leading-none lg:text-lg w-full',
          { 'text-primary': isWinner },
          { 'font-bold': isKok },
        ]"
      >
        {{ isKok ? team.completeName : team.shortName }}
      </p>
    </div>
    <NuxtImg
      v-if="team?.logo && !isKok"
      :src="setAliasUrl(team.logo.url)"
      class="lg:w-12 w-9"
      :alt="team.completeName || ''"
      loading="lazy"
      width="48"
      height="48"
    />
  </div>
</template>

<style scoped></style>
